import { useEffect, useRef, useState } from 'react';
import 'animate.css';

export function RevealEffect({
	children,
	className = '',
	animation = 'animate__fadeInUp',
	once = true,
	threshold = 0.15,
	rootMargin = '0px 0px -10% 0px',
}) {
	const ref = useRef(null);
	const [shown, setShown] = useState(false);

	useEffect(() => {
		const el = ref.current;
		if (!el) return;

		const obs = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setShown(true);
					if (once) obs.disconnect();
				} else if (!once) {
					setShown(false);
				}
			},
			{ threshold, rootMargin },
		);

		obs.observe(el);
		return () => obs.disconnect();
	}, [once, threshold, rootMargin]);

	return (
		<div
			ref={ref}
			className={[
				className,
				shown ? `animate__animated ${animation}` : 'opacity-0',
			].join(' ')}
		>
			{children}
		</div>
	);
}
